﻿import { defineComponent } from 'vue';

import { request_login } from "../../booking_engine/objects/agent/identity/v1_3/request_login"

import login_screen from "../login_screen.vue";

export default defineComponent({
    components: {
        login_screen
    },
    props: {
    },
    data() {
        return {
            logging_in: false as boolean
        }
    },
    methods: {
    },
    mounted() {
    }
});